import styled from 'styled-components';

export default styled.div`
  display: grid;
  text-align: center;
  flex: 1;
  grid-template-rows: 1fr 1fr 1fr;
  align-content: space-between;

  .text {
    grid-row: 2;
  }

  .actions {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 10px;

    button {
      white-space: nowrap;
    }
  }
`;
